(function() {
	'use strict';
	angular.module('approot', ['app', 'appback']);
})();
(function() {
	'use strict';
	angular.module('appback', ['ui.bootstrap', 'ngFileUpload', 'chieffancypants.loadingBar', 'daterangepicker']).config(function($httpProvider, cfpLoadingBarProvider) {
		// $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
		$httpProvider.defaults.headers.post['X-CSRF-Token'] = jQuery('meta[name="csrf-token"]').attr("content");
		$httpProvider.defaults.timeout = 30000;
		cfpLoadingBarProvider.spinnerTemplate = `
     <div id="loading-bar-spinner"> 
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 150"><path fill="none" stroke="#FF156D" stroke-width="15" stroke-linecap="round" stroke-dasharray="300 385" stroke-dashoffset="0" d="M275 75c0 31-27 50-50 50-58 0-92-100-150-100-28 0-50 22-50 50s23 50 50 50c58 0 92-100 150-100 24 0 50 19 50 50Z"><animate attributeName="stroke-dashoffset" calcMode="spline" dur="2" values="685;-685" keySplines="0 0 1 1" repeatCount="indefinite"></animate></path></svg>
      </div>
    `;
	}).config(["$interpolateProvider", function($interpolateProvider) {
		$interpolateProvider.startSymbol("[[");
		$interpolateProvider.endSymbol("]]");
	}])


})();
